import React, { useState } from "react";
import { Card, Tab, Nav, Row, Col, Dropdown, Image } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TbWorld, TbBuildingHospital } from "react-icons/tb";
import ViewInfoModal from "../../modals/hrm/employee/employeedetails/ViewInfoModal";
import RaiseIssueModal from "../../modals/hrm/employee/employeedetails/RaiseIssueModal";

import project from "../../../assets/img/social/project-03.svg";
import project1 from "../../../assets/img/social/project-01.svg";
import computer from "../../../assets/img/products/product-05.jpg";
import computer2 from "../../../assets/img/products/product-06.jpg";

export default function ProjectsAssets() {
  const [showViewInfo, setShowViewInfo] = useState(false);
  const [showRaiseIssue, setShowRaiseIssue] = useState(false);

  return (
    <Card
      className=" mt-3"
      style={{
        border: "1px solid #dbe2ea",
        borderRadius: "6px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
      }}
    >
      <Card.Body style={{ padding: "16px 20px" }}>
        <Tab.Container defaultActiveKey="projects">
      <Nav
  variant="underline"
  className="mb-4"
  style={{
    borderBottom: "1px solid #e5e7eb",
    gap: "28px"
  }}
>
  <Nav.Item>
    <Nav.Link
      eventKey="projects"
      style={{
        fontSize: "18px",
        paddingBottom: "12px",
        color: "#64748b"
      }}
      className="text-secondary"
    >
      Projects
    </Nav.Link>
  </Nav.Item>

  <Nav.Item>
    <Nav.Link
      eventKey="assets"
      style={{
        fontSize: "18px",
        paddingBottom: "12px",
        color: "#64748b"
      }}
      className="text-secondary"
    >
      Assets
    </Nav.Link>
  </Nav.Item>
</Nav>

          <Tab.Content>
            <Tab.Pane eventKey="projects">
              <Row className="g-4">
                <Col md={6}>
                  <Card
                    style={{ border: "1px solid #dbe2ea", borderRadius: "7px" }}
                  >
                    <Card.Body style={{ padding: "28px 26px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            borderRadius: "50%",
                            background: "#0d6efd",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <img src={project} alt="" />
                        </div>

                        <div>
                          <div
                            style={{
                              fontSize: "17px",
                              fontWeight: "600",
                              marginBottom: "2px",
                            }}
                          >
                            World Health
                          </div>
                          <div style={{ fontSize: "15px", color: "#6b7280" }}>
                            8 tasks{" "}
                            <span style={{ color: "#f97316", margin: "0 6px" }}>
                              •
                            </span>{" "}
                            15 Completed
                          </div>
                        </div>
                      </div>

                      <hr style={{ margin: "24px 0", opacity: 0.12 }} />

                      <Row>
                        <Col xs={6}>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#6b7280",
                              marginBottom: "8px",
                            }}
                          >
                            Deadline
                          </div>
                          <div style={{ fontSize: "17px" }}>31 July 2025</div>
                        </Col>

                        <Col xs={6}>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#6b7280",
                              marginBottom: "8px",
                            }}
                          >
                            Project Lead
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src="https://randomuser.me/api/portraits/women/44.jpg"
                              alt="lead"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                              }}
                            />
                            <span style={{ fontSize: "17px" }}>Leona</span>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card
                    style={{ border: "1px solid #dbe2ea", borderRadius: "7px" }}
                  >
                    <Card.Body style={{ padding: "28px 26px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            borderRadius: "50%",
                            background: "#5b5ce9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <img src={project1} alt="" />
                        </div>

                        <div>
                          <div
                            style={{
                              fontSize: "17px",
                              fontWeight: "600",
                              marginBottom: "2px",
                            }}
                          >
                            Hospital Administration
                          </div>
                          <div style={{ fontSize: "15px", color: "#6b7280" }}>
                            8 tasks{" "}
                            <span style={{ color: "#f97316", margin: "0 6px" }}>
                              •
                            </span>{" "}
                            15 Completed
                          </div>
                        </div>
                      </div>

                      <hr style={{ margin: "24px 0", opacity: 0.12 }} />

                      <Row>
                        <Col xs={6}>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#6b7280",
                              marginBottom: "8px",
                            }}
                          >
                            Deadline
                          </div>
                          <div style={{ fontSize: "17px" }}>31 July 2025</div>
                        </Col>

                        <Col xs={6}>
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#6b7280",
                              marginBottom: "8px",
                            }}
                          >
                            Project Lead
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src="https://randomuser.me/api/portraits/women/44.jpg"
                              alt="lead"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                              }}
                            />
                            <span style={{ fontSize: "17px" }}>Leona</span>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab.Pane>

            <Tab.Pane eventKey="assets">
              <Card
                className="mb-4"
                style={{ border: "1px solid #dbe2ea", borderRadius: "7px" }}
              >
                <Card.Body style={{ padding: "26px 24px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <img
                        src={computer}
                        alt="laptop"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: "600", fontSize: "17px" }}>
                          Dell Laptop - #343556656
                        </div>
                        <div style={{ marginTop: "4px", fontSize: "15px" }}>
                          <span style={{ color: "#f97316" }}>AST - 001</span>
                          <span style={{ color: "#f97316", margin: "0 8px" }}>
                            •
                          </span>
                          <span style={{ color: "#6b7280" }}>
                            Assigned on 22 Nov, 2022 10:32AM
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "40px",
                      }}
                    >
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "15px" }}>
                          Assigned by
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <img
                            src="https://randomuser.me/api/portraits/women/44.jpg"
                            alt="user"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          />
                          <span style={{ fontSize: "16px" }}>Andrew Symon</span>
                        </div>
                      </div>

                      <Dropdown>
                        <Dropdown.Toggle as="div" style={{ cursor: "pointer" }}>
                          <BsThreeDotsVertical size={20} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setShowViewInfo(true)}>
                            View Info
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setShowRaiseIssue(true)}
                          >
                            Raise Issue
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card
                style={{ border: "1px solid #dbe2ea", borderRadius: "7px" }}
              >
                <Card.Body style={{ padding: "26px 24px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <img
                        src={computer2}
                        alt="mouse"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: "600", fontSize: "17px" }}>
                          Bluetooth Mouse - #478878
                        </div>
                        <div style={{ marginTop: "4px", fontSize: "15px" }}>
                          <span style={{ color: "#f97316" }}>AST - 001</span>
                          <span style={{ color: "#f97316", margin: "0 8px" }}>
                            •
                          </span>
                          <span style={{ color: "#6b7280" }}>
                            Assigned on 22 Nov, 2022 10:32AM
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "40px",
                      }}
                    >
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "15px" }}>
                          Assigned by
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <img
                            src="https://randomuser.me/api/portraits/women/44.jpg"
                            alt="user"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          />
                          <span style={{ fontSize: "16px" }}>Andrew Symon</span>
                        </div>
                      </div>

                      <Dropdown>
                        <Dropdown.Toggle as="div" style={{ cursor: "pointer" }}>
                          <BsThreeDotsVertical size={20} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setShowViewInfo(true)}>
                            View Info
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setShowRaiseIssue(true)}
                          >
                            Raise Issue
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <style>
{`
.nav-underline .nav-link.active{
color:#f97316 !important;
border-bottom:2px solid #f97316 !important;
}
`}
</style>
      </Card.Body>

      <ViewInfoModal
        show={showViewInfo}
        handleClose={() => setShowViewInfo(false)}
      />

      <RaiseIssueModal
        show={showRaiseIssue}
        handleClose={() => setShowRaiseIssue(false)}
      />
    </Card>
  );
}
